import { alpha } from '@mui/material/styles';
import {
  DASHBOARD_ACCENT,
  getDashboardDarkSurfaceTokens,
  getDashboardPageShellSx,
  getDashboardPaperSx,
  getDashboardSectionContentPaperSx,
} from './dashboardSurfaceSx';

export const HOUSEKEEPING_ACCENT = DASHBOARD_ACCENT;

export { getDashboardDarkSurfaceTokens, getDashboardPageShellSx };

export function getHousekeepingThemeColors(isDark) {
  return getDashboardDarkSurfaceTokens(isDark);
}

export function getHousekeepingTabsPaperSx(isDark) {
  return {
    mb: 3,
    overflow: 'hidden',
    p: { xs: 1, sm: 1.5 },
    ...getDashboardSectionContentPaperSx(isDark, false, { p: { xs: 1, sm: 1.5 }, minHeight: 0 }),
  };
}

/** Datatable / list card — matches Booking List surface. */
export function getHousekeepingListPaperSx(isDark) {
  const themeMode = isDark ? 'dark' : 'light';
  return {
    ...getDashboardPaperSx(themeMode, 'controls'),
    mb: 0,
    overflow: 'hidden',
  };
}

export function getHousekeepingPanelPaperSx(isDark, extra = {}) {
  const tokens = getDashboardDarkSurfaceTokens(isDark);
  return {
    background: tokens.surfaceGradient,
    border: `1px solid ${tokens.surfaceBorder}`,
    borderRadius: 2,
    boxShadow: isDark ? 'inset 0 1px 0 rgba(255,255,255,0.04)' : 'none',
    ...extra,
  };
}

export function getHousekeepingDrawerPaperSx(isDark) {
  const tokens = getDashboardDarkSurfaceTokens(isDark);
  return {
    backgroundColor: isDark ? tokens.surface : '#ffffff',
    borderLeft: isDark ? `1px solid ${tokens.surfaceBorder}` : undefined,
  };
}

export function getHousekeepingDrawerHeaderSx(isDark) {
  const tokens = getDashboardDarkSurfaceTokens(isDark);
  return {
    borderBottom: `2px solid ${tokens.surfaceBorderStrong}`,
    backgroundColor: tokens.headerBg,
  };
}

export function getHousekeepingDrawerFooterSx(isDark) {
  const tokens = getDashboardDarkSurfaceTokens(isDark);
  return {
    borderTop: `2px solid ${tokens.surfaceBorderStrong}`,
    backgroundColor: tokens.headerBg,
  };
}

export function getHousekeepingChipSx(isDark) {
  const tokens = getDashboardDarkSurfaceTokens(isDark);
  return {
    backgroundColor: tokens.chipBg,
    color: tokens.text,
  };
}

export function getHousekeepingRoomCardSx(isDark, options = {}) {
  const tokens = getDashboardDarkSurfaceTokens(isDark);
  const { hasMaintenance = false, accentColor = HOUSEKEEPING_ACCENT } = options;
  return {
    p: 0,
    height: '100%',
    minHeight: 172,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    overflow: 'hidden',
    borderRadius: '18px',
    background: isDark
      ? `linear-gradient(180deg, ${alpha(accentColor, 0.1)} 0%, ${tokens.surface} 38%, ${tokens.background} 100%)`
      : `linear-gradient(180deg, ${alpha(accentColor, 0.1)} 0%, #ffffff 42%, #f8fafc 100%)`,
    border: `1px solid ${hasMaintenance ? alpha('#ff9800', 0.65) : alpha(accentColor, isDark ? 0.35 : 0.28)}`,
    boxShadow: hasMaintenance
      ? (isDark
        ? `0 8px 22px ${alpha('#ff9800', 0.18)}, inset 0 1px 0 ${alpha('#ffffff', 0.06)}`
        : `0 8px 20px ${alpha('#ff9800', 0.12)}`)
      : (isDark
        ? `0 8px 22px rgba(0,0,0,0.3), inset 0 1px 0 ${alpha('#ffffff', 0.06)}`
        : `0 8px 20px ${alpha('#0f172a', 0.06)}`),
    transition: 'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-3px)',
      borderColor: hasMaintenance ? '#ff9800' : HOUSEKEEPING_ACCENT,
      boxShadow: isDark
        ? `0 14px 28px rgba(0,0,0,0.38), 0 0 0 1px ${alpha(HOUSEKEEPING_ACCENT, 0.22)}`
        : `0 14px 28px ${alpha('#0f172a', 0.1)}, 0 0 0 1px ${alpha(HOUSEKEEPING_ACCENT, 0.2)}`,
    },
  };
}
